import EnumCommon from './EnumCommon';
class ApplicationStatus extends EnumCommon {
    labels() {
        return {
            [10]: 'models/applications.statuses.draft',
            [20]: 'models/applications.statuses.sent',
            [30]: 'models/applications.statuses.canceled',
            [40]: 'models/applications.statuses.accepted',
            [50]: 'models/applications.statuses.in_review',
            [60]: 'models/applications.statuses.rejected',
            [70]: 'models/applications.statuses.returned',
            [80]: 'models/applications.statuses.archived',
        };
    }
}
ApplicationStatus.NAME = 'ApplicationStatus';
ApplicationStatus.DRAFT = new ApplicationStatus(10);
ApplicationStatus.SENT = new ApplicationStatus(20);
ApplicationStatus.CANCELED = new ApplicationStatus(30);
ApplicationStatus.ACCEPTED = new ApplicationStatus(40);
ApplicationStatus.IN_REVIEW = new ApplicationStatus(50);
ApplicationStatus.REJECTED = new ApplicationStatus(60);
ApplicationStatus.RETURNED = new ApplicationStatus(70);
ApplicationStatus.ARCHIVED = new ApplicationStatus(80);
export default ApplicationStatus;
